import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/api";
import { canAccess, landingFor } from "../lib/roles";

/**
 * ProtectedRoute — enforces auth + role-based access on the frontend.
 * The backend also enforces roles independently; this component only controls the UI/routing UX.
 *
 * Usage: <ProtectedRoute path="/pipeline">…</ProtectedRoute>
 * (`path` MUST match a key in PAGE_ROLES from /src/lib/roles.js.)
 */
export default function ProtectedRoute({ children, path }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F7FAFC] flex items-center justify-center">
        <div className="text-xs font-mono uppercase tracking-wider text-slate-500">Verifying session…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  const requestedPath = path || location.pathname;
  if (!canAccess(user.role, requestedPath)) {
    // Send user to their role's landing page — never expose "forbidden" UI mid-route.
    return <Navigate to={landingFor(user.role)} replace />;
  }
  return children;
}
